/*eslint-disable eqeqeq*/

import React from 'react';

class FlavourColumn extends React.Component {

  render() {
  	if(!this.props.flavours) {
  		return null
  	}

    return this.props.flavours.map((flavour) => {

      // TODO: Should always get an integer, force when save. Remove eslint-disable when done.
      if(this.props.hideUnused && this.props.currentBrew[flavour.variable] == 0) {
        return null
      }

      return (
        <div key={ flavour.variable } className={`flavours__column flavours__column--${ flavour.variable }`}>
          <label className="flavours__label">
            <span className="flavours__name">{ flavour.label }</span>
            <input className="flavours__input" name={ flavour.variable } min="0" max="5" type="number" value={ this.props.currentBrew[flavour.variable] } onChange={ this.props.onChange } disabled={ (this.props.readOnlyMode) ? "disabled" : "" } />
            <div className="flavours__meter" style={{width: `${this.props.currentBrew[flavour.variable] * 20}%` }}></div>
          </label>
        </div>
      )
    })
  }
}

export default FlavourColumn;
